import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    FaSearch,
    FaUserTie,
    FaSeedling,
    FaArrowRight
} from "react-icons/fa";
import { GiCow } from "react-icons/gi";

import "../../styles/HeroSection.css";

export default function HeroSection() {
 const { t } = useTranslation();
    const navigate = useNavigate();

    return (
    <div
      className="hero-section"
      style={{
        backgroundImage:
          "url('/images/hero-agriculture.jpg')",
      }}
    >
      <div className="hero-overlay">

        <div className="container">

          <h1>
            {t("common.welcome")}
          </h1>

          <p>
       {t("common.welcomeDescription")}
       {t("common.welcome")}
          </p>



        </div>

      </div>
    </div>
  );
}